import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function BlogCTA({ text, to, btnText }) {
  return (
    <div className="my-10 p-6 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 rounded-2xl">
      <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed mb-4">{text}</p>
      <Link
        to={to}
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-xl transition-all duration-200 text-sm"
      >
        {btnText} <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
